<template>
  <g>
    <g clip-path="url(#clip0_26066_285925)">
      <path
        d="M21 4.5H19.5V1.5H18V4.5H16.5V13.5H18V16.5H19.5V13.5H21V4.5ZM19.5 12H18V6H19.5V12Z"
      />
      <path
        d="M9.5 7H8V4H6.5V7H5V14.5H6.5V17.5H8V14.5H9.5V7ZM8 13H6.5V8.5H8V13Z"
      />
      <path d="M15.5 9H14V6H12.5V9H11V16.5H12.5V19.5H14V16.5H15.5V9Z" />
      <path
        d="M22.5 22.5H3C2.60218 22.5 2.22064 22.342 1.93934 22.0607C1.65804 21.7794 1.5 21.3978 1.5 21V1.5H3V21H22.5V22.5Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_26066_285925">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </g>
</template>
